import { HomeIcon, InfoIcon, ListIcon, PassportIcon } from "@components/icons";
import { ClipboardText } from "@phosphor-icons/react";
import { useFeatureGate } from "@statsig/react-bindings";
import { cn } from "@utils/cn";
import { useContact } from "@utils/hooks";
import { useCallback } from "react";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";

export type PageOptions =
  | "home"
  | "actions"
  | "docs"
  | "help"
  | "track"
  | "onboarding"
  | "onboarding/employer";

export const allPages: {
  title: string;
  page: PageOptions;
  icon: React.ElementType;
}[] = [
    {
      title: "Home",
      page: "home",
      icon: HomeIcon,
    },
    // {
    //   title: "Action Items",
    //   page: "onboarding",
    //   icon: Flag,
    //   notificationCount: 5,
    // },
    {
      title: "Action Items",
      page: "actions",
      icon: ClipboardText,
    },
    {
      title: "Documents",
      page: "docs",
      icon: PassportIcon,
    },
    // {
    //   title: "Onboarding",
    //   page: "onboarding/employer",
    //   icon: ListIcon,
    // },
    // {
    //   title: "Track your Petition",
    //   page: "track",
    //   icon: <MapPin strokeWidth={1} size={24} />,
    // },
    {
      title: "Help",
      page: "help",
      icon: InfoIcon,
    },
  ];

export function MainNav({
  className,
  ...props
}: React.HTMLAttributes<HTMLElement> & {
  selectedPage?: PageOptions;
}) {
  const navProps = {
    ...props,
  };
  const { team } = useContact();
  delete navProps["selectedPage"];

  const nav = useNavigate();
  const location = useLocation();
  const featureGate = useFeatureGate("beneficiary-onboarding");
  const beneficiaryOnboarding = featureGate?.value ?? true;

  const doNavigatePage = useCallback(
    (page: PageOptions) => {
      if (page === "help") {
        window.open("https://www.plymouthstreet.com/resources", "_blank");
        return;
      }
      nav({
        pathname: `/${page === "home" ? "" : page}`,
        search:
          new URLSearchParams(location.search).get("readOnly") === "true"
            ? createSearchParams({ readOnly: "true" }).toString()
            : "",
      });
    },
    [nav, location]
  );

  const relevantPages = allPages.filter((page) => {
    if (page.page === "onboarding/employer") {
      return team?.type === "team" && team?.portalOnboarded === true;
    }

    if (team?.type === "team") {
      return page.page !== "actions" && page.page !== "track";
    }

    if (team?.type === "personal" && beneficiaryOnboarding) {
      return page.page !== "actions";
    }

    return true;
  });

  return (
    <nav
      className={cn("flex flex-col space-y-4 lg:space-y-6", className)}
      {...navProps}
    >
      {relevantPages.map((page) => {
        const isSelected =
          props.selectedPage === page.page ||
          (page.page === "onboarding/employer" &&
            props.selectedPage === "onboarding");
        return (
          <a
            key={page.page}
            onClick={() => doNavigatePage(page.page)}
            className={cn(
              "flex flex-row items-center p-2 hover:cursor-pointer relative space-x-2",
              isSelected ? "text-accent" : "text-muted-foreground"
            )}
            title={page.title}
          >
            {
              <div
                className={cn(
                  "p-1",
                  isSelected
                    ? "bg-[#DCF0FC] rounded-[6px] border border-[#DCF0FC]"
                    : ""
                )}
              >
                <page.icon
                  size={14}
                  className={cn("rounded w-9 h-9", "text-muted-foreground")}
                />
              </div>
            }
          </a>
        );
      })}
    </nav>
  );
}
